// extracted by mini-css-extract-plugin
module.exports = {"w1eyykcs":"w1eyykcs","h1e27qv9":"h1e27qv9"};